import * as React from 'react'

import ProductLink from 'src/components/Product/ProductLink/ProductLink'

import styles from './Swatches.module.scss'

type Props = {
  products: any
  selected: any
}

const Swatches = ({ products, selected }: Props): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      {products.slice(0, 6).map((product: any, index: number) => {
        const { infoColorSwatch } = product
        if (!infoColorSwatch) {
          return null
        }

        const background = infoColorSwatch.color
          ? { background: `url(${infoColorSwatch.color.url})` }
          : { background: infoColorSwatch.hex }

        const active = selected === product.product

        return (
          <ProductLink product={product} key={index}>
            <div
              className={
                active
                  ? [styles.swatch, styles.active].join(' ')
                  : styles.swatch
              }
              style={{ ...background }}
            />
          </ProductLink>
        )
      })}
    </div>
  )
}

export default Swatches
